import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

const useEncounterExpectedCodes = ({ testRunId }: { testRunId: string | undefined }) => {
  const queryResult = useQuery({
    queryKey: ["test-run-encounter-expected-codes", testRunId],
    enabled: !!testRunId,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("test_encounter_results")
        .select(
          `
          *,
          test_encounter:patient_encounters (
            id,
            expected_procedures:test_encounter_expected_procedures (
              id,
              opcs4_code_id,
              order_index,
              opcs4_codes (
                code,
                description
              )
            ),
            expected_diagnoses:test_encounter_expected_diagnoses (
              id,
              icd10_code_id,
              is_optional,
              order_index,
              icd10_codes:icd10_codes (
                code,
                description
              )
            )
          )
        `,
        )
        .eq("test_classification_run_results_id", testRunId!)
        .maybeSingle();

      if (error) {
        throw new Error(error.message);
      }

      return data;
    },
  });

  return queryResult;
};

export default useEncounterExpectedCodes;
